import { render, staticRenderFns } from "./OrderCorrectiveReview.vue?vue&type=template&id=e05c118c&"
import script from "./OrderCorrectiveReview.vue?vue&type=script&lang=js&"
export * from "./OrderCorrectiveReview.vue?vue&type=script&lang=js&"
import style0 from "./OrderCorrectiveReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports